import { render, staticRenderFns } from "./Data_modal.vue?vue&type=template&id=99d0304c&lang=pug&"
import script from "./Data_modal.vue?vue&type=script&lang=js&"
export * from "./Data_modal.vue?vue&type=script&lang=js&"
import style0 from "./Data_modal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports